import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "spinner",
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24 12.7273C24 19.3547 18.6274 24.7273 12 24.7273C5.37258 24.7273 0 19.3547 0 12.7273C0 6.09985 5.37258 0.727264 12 0.727264C18.6274 0.727264 24 6.09985 24 12.7273ZM3.36 12.7273C3.36 17.499 7.22826 21.3673 12 21.3673C16.7717 21.3673 20.64 17.499 20.64 12.7273C20.64 7.95552 16.7717 4.08726 12 4.08726C7.22826 4.08726 3.36 7.95552 3.36 12.7273Z",
			fill: "#E4E5EB"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_6641_15259",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M12.4991 2.41934C12.544 1.49259 11.826 0.692683 10.9021 0.777571C8.67925 0.981795 6.5453 1.80351 4.74904 3.1657C2.50413 4.86811 0.92981 7.30613 0.301858 10.0527C-0.326095 12.7992 0.0323641 15.6791 1.31444 18.1879C2.3403 20.1953 3.90515 21.8627 5.81839 23.0126C6.61365 23.4906 7.6079 23.0821 7.97021 22.228C8.33251 21.3738 7.92093 20.4001 7.15286 19.8795C5.95529 19.0679 4.97286 17.9631 4.3064 16.6589C3.3833 14.8526 3.12521 12.7791 3.57734 10.8016C4.02946 8.82405 5.16298 7.06867 6.77931 5.84294C7.94628 4.95797 9.31121 4.38983 10.7425 4.17925C11.6604 4.0442 12.4543 3.34609 12.4991 2.41934Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4991 2.41934C12.544 1.49259 11.826 0.692683 10.9021 0.777571C8.67925 0.981795 6.5453 1.80351 4.74904 3.1657C2.50413 4.86811 0.92981 7.30613 0.301858 10.0527C-0.326095 12.7992 0.0323641 15.6791 1.31444 18.1879C2.3403 20.1953 3.90515 21.8627 5.81839 23.0126C6.61365 23.4906 7.6079 23.0821 7.97021 22.228C8.33251 21.3738 7.92093 20.4001 7.15286 19.8795C5.95529 19.0679 4.97286 17.9631 4.3064 16.6589C3.3833 14.8526 3.12521 12.7791 3.57734 10.8016C4.02946 8.82405 5.16298 7.06867 6.77931 5.84294C7.94628 4.95797 9.31121 4.38983 10.7425 4.17925C11.6604 4.0442 12.4543 3.34609 12.4991 2.41934Z",
			fill: "#4F68CB",
			stroke: "#E4E5EB",
			strokeWidth: .4,
			mask: "url(#path-2-inside-1_6641_15259)"
		})
	]
});
export default SvgSpinner;
